module.exports = __webpack_public_path__ + "img/ai.2a693765.png";